import { useNavigate } from "react-router-dom";
import useModal from "../../services/useModal";
import Modal from "../common/Modal";
import SimpleButton from "../common/SimpleButton";
import ModalDaily from "../ModalDaily";
import imgNavHome from "../../assets/images/nav_home.webp"
import imgNavDaily from "../../assets/images/nav_daily.webp"
import imgNavLeaders from "../../assets/images/nav_leaders.webp"

import s from './FooterNavigation.module.css'

const FooterNavigation = () => {
    const navigate = useNavigate();

    const navigateWithDelay = (path: string) => {
        setTimeout(() => {
            navigate(path);
        }, 200);
    };

    const goToMain = () => navigateWithDelay("/main");
    // const goToDaily = () => navigateWithDelay("/daily");
    const goToLeaders = () => navigateWithDelay("/leaders");

    // DAILY
    const { isOpen: isModalOpenDaily,
        isFadingOut: isFadingOutDaily,
        openModal: openModalDaily,
        closeModal: closeModalDaily } = useModal();

    return (
        <div className={s.navContainer}>
            <SimpleButton className={s.imgNavHome} onClick={goToMain} imageUrl={imgNavHome} />
            {/* <SimpleButton className={s.imgNavDaily} onClick={goToDaily} imageUrl={imgNavDaily} /> */}
            <SimpleButton className={s.imgNavDaily} onClick={openModalDaily} imageUrl={imgNavDaily} />
            <SimpleButton className={s.imgNavLeaders} onClick={goToLeaders} imageUrl={imgNavLeaders} />

            {isModalOpenDaily && <Modal closeModal={closeModalDaily} isFadingOut={isFadingOutDaily}>
                <ModalDaily closeModal={closeModalDaily} />
            </Modal>}
        </div>
    )
}

export default FooterNavigation